__webpack_require__.p = "/equitable-syllabus-project/";